import { showAlertMsg } from './member-show-alert-msg.js';
import { memberRoutes, memberPages, withMemberCongregationQuery, memberNavigateTo } from './member-nav-config.js';
import { navigateWithOverlay } from '../shared/guarded-navigation.js';
import { handleMemberSpaRequestError } from './member-spa-auth.js';
import { syncFullPageBodyClasses } from './member-spa-ajax.js';
import { applyCsrfToken } from '../shared/csrf-token.js';

const OPEN_INDEX_IN_FLIGHT = Symbol.for('kiosk.openIndexPage.inFlight');
const PAYMENT_RECEIVED_HOME_BOUND = Symbol.for('kiosk.paymentReceivedHome.bound');

function isStatementPaymentHostPage() {
    return Boolean(document.getElementById('statement-email-page-config'));
}

function showMemberHomeFromPayload(pageInfo) {
    $('body').removeClass('shabbos-mode-active member-pledges-full-page account-settings-full-page');
    $('#index_paging').html(pageInfo).fadeIn('slow');
    $('body').toggleClass('login-flow-active', $('#index_paging .login-flow-page').length > 0);
    syncFullPageBodyClasses();
    memberNavigateTo('home');
}

export function openIndexPage() {
    if (globalThis[OPEN_INDEX_IN_FLIGHT]) {
        return;
    }

    if (document.querySelector('#index_paging .member-home-layout')) {
        $('body').removeClass('shabbos-mode-active');
        syncFullPageBodyClasses();
        memberNavigateTo('home');
        return;
    }

    globalThis[OPEN_INDEX_IN_FLIGHT] = true;
    $('body').removeClass('shabbos-mode-active');
    navigateWithOverlay({
        url: withMemberCongregationQuery(memberRoutes().index2),
        type: 'GET',
        success(data) {
            if (data.success) {
                if (data.csrf_token) {
                    applyCsrfToken(data.csrf_token);
                }
                showMemberHomeFromPayload(data.page_info);
            } else {
                showAlertMsg(data.error, 'danger');
            }
        },
        error: handleMemberSpaRequestError,
        complete() {
            globalThis[OPEN_INDEX_IN_FLIGHT] = false;
        },
    });
}

export function redirectToIndexPage() {
    window.location.assign(memberPages().home);
}

export function goHomeFromPaymentReceived() {
    if (isStatementPaymentHostPage()) {
        redirectToIndexPage();
        return;
    }
    openIndexPage();
}

if (window.jQuery && !globalThis[PAYMENT_RECEIVED_HOME_BOUND]) {
    globalThis[PAYMENT_RECEIVED_HOME_BOUND] = true;
    window.jQuery(document).on(
        'click.paymentReceivedHome',
        '[data-payment-received-action="home"]',
        function (event) {
            event.preventDefault();
            goHomeFromPaymentReceived();
        }
    );
}
